import { createSvgComponent } from "../../icon/createSvgComponent";
import Store from "@core/icon/assets/store.svg";
export default createSvgComponent(Store);